import { render, staticRenderFns } from "./TreeMenu.vue?vue&type=template&id=e0522b9a&scoped=true&"
import script from "./TreeMenu.vue?vue&type=script&lang=js&"
export * from "./TreeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0522b9a",
  null
  
)

export default component.exports